//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import BtnBack from '../BtnBack.vue';
import PostMeta from '../PostMeta.vue';
import Btn from '../Btn.vue';
import ProductTile from '../ProductTile.vue';
import PostSocial from '../PostSocial.vue';

export default {
	name: 'PageRecipesInner',

	components: { PageBanner: PageBanner, PageLimiter: PageLimiter, Breadcrumbs: Breadcrumbs, BtnBack: BtnBack, PostMeta: PostMeta, Btn: Btn, ProductTile: ProductTile, PostSocial: PostSocial },

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		content: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	data: function data() {
		return {
			portionCount: 1
		};
	},


	computed: {
		stepshtml: function stepshtml() {
			var steps = this.content.steps.map(function (element) {
				var entityMap = {
					"&lt;": "<",
					"&gt;": ">"
				};
				return String(element).replace(/(&lt;)|(&gt;)/g, function (s) {
					return entityMap[s];
				});
			});
			return steps;
		},
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		factor: function factor() {
			return this.content.portionCount || 1;
		},
		ings: function ings() {
			var _this = this;

			return (this.content.ings || []).map(function (item) {
				var ob = {
					title: item.title,
					value: item.value,
					link: item.link
				};

				if (ob.value === '') {
					ob.value = _this.portionCount === _this.factor ? '' : _this.portionCount / _this.factor;
				} else if (ob.value !== null) {
					ob.value = parseInt(ob.value, 10) * (_this.portionCount / _this.factor);
				}

				ob.unit = _this.$lang(item.unitKey, ob.value || 1, _this.lang);
				return ob;
			});
		},
		productSection: function productSection() {
			return this.content.productSection || {};
		},
		products: function products() {
			return this.productSection.items || [];
		}
	},

	methods: {
		portionMinus: function portionMinus() {
			this.portionCount = this.portionCount === this.factor ? this.factor : this.portionCount - this.factor;
		},
		portionPlus: function portionPlus() {
			this.portionCount += this.factor;
		}
	},

	created: function created() {
		this.portionCount = this.factor;
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageRecipesInner.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageRecipesInner.vue
// module chunks = 1 2